import React, { Fragment, useState, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import matchSorter from 'match-sorter';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatDateDefault } from 'services/DateFormatters';
import { TIGHT_FIT_PARAM } from 'constants/System';
import { setFeature } from 'actions/feature';

const FeatureTable = () => {
    const dispatch = useDispatch();
    const width = useSelector((state) => state.settings.width);
    const featureList = useSelector((state) => state.features.featureList);
    const selectedFeature = useSelector((state) => state.features.selectedFeature);
    const [selected, setSelected] = useState(0);

    useLayoutEffect(() => {
        const selected = featureList.findIndex((entry) => entry?.id === selectedFeature?.id) || 0;
        setSelected(selected);
    }, []);

    const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
    const styledSummaryColumn = (value) => {
        return (
            <Fragment>
                <span className="d-inline-block text-black">
                    <div className="font-weight-bold">{value}</div>
                </span>
            </Fragment>
        );
    };
    const priorityColumn = {
        Header: 'Priority',
        id: 'priority',
        accessor: (d) => d?.priority || 'unknown',
        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['priority'] }),
        filterAll: true,
        width: defaultWidth,
    };
    const nameColumn = {
        Header: 'Name',
        id: 'name',
        accessor: (d) => d?.name,
        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['name'] }),
        Cell: ({ value }) => {
            return styledSummaryColumn(value);
        },
        filterAll: true,
    };
    const startDateColumn = {
        Header: 'Start Date',
        id: 'startDate',
        accessor: (d) => d?.startDate,
        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['startDate'] }),
        filterAll: true,
        Cell: ({ value }) => {
            return formatDateDefault(value);
        },
        width: defaultWidth,
    };
    const endDateColumn = {
        Header: 'End Date',
        id: 'endDate',
        accessor: (d) => d?.endDate,
        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['endDate'] }),
        filterAll: true,
        Cell: ({ value }) => {
            return formatDateDefault(value);
        },
        width: defaultWidth,
    };

    const columnsList = new Array();
    columnsList.push(nameColumn);
    if (width > TIGHT_FIT_PARAM) {
        columnsList.push(priorityColumn);
        columnsList.push(startDateColumn);
        columnsList.push(endDateColumn);
    }
    return (
        <div>
            <ReactTable
                data={featureList}
                filterable
                defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
                columns={[
                    {
                        columns: columnsList,
                    },
                ]}
                defaultPageSize={10}
                getTrProps={(state, rowInfo) => {
                    if (rowInfo && rowInfo.row) {
                        return {
                            onClick: () => {
                                // console.log(JSON.stringify(rowInfo?.index));
                                dispatch(setFeature(rowInfo?.original?.id));
                                setSelected(rowInfo.index);
                            },
                            style: {
                                background: rowInfo.index === selected ? '#cfd8dc' : 'white',
                                color: rowInfo.index === selected ? 'black' : 'black',
                            },
                        };
                    } else {
                        return {};
                    }
                }}
            />
        </div>
    );
};

export default FeatureTable;



// WEBPACK FOOTER //
// ./components/Agile/feature/featureTable/index.js